<script lang="ts" setup>
import { computed } from 'vue'
import { type PColOrder, type PColSize } from './types'

type Props = {
  mobile: PColSize
  laptop?: PColSize
  desktop?: PColSize
  orderMobile?: PColOrder | null
  orderLaptop?: PColOrder | null
  orderDesktop?: PColOrder | null
}

const props = withDefaults(defineProps<Props>(), {
  orderMobile: null,
  orderLaptop: null,
  orderDesktop: null,
})

const orderMobileWithFallback = computed<number>(() => {
  return props.orderMobile !== null ? props.orderMobile : 0
})

const orderLaptopWithFallback = computed<number>(() => {
  return props.orderLaptop !== null ? props.orderLaptop : orderMobileWithFallback.value
})

const orderDesktopWithFallback = computed<number>(() => {
  return props.orderDesktop !== null ? props.orderDesktop : orderLaptopWithFallback.value
})
</script>

<template>
  <div
    :class="`p-col-mobile-${mobile} p-col-laptop-${laptop || mobile} p-col-desktop-${desktop || laptop || mobile} ds-col-order-mobile ds-col-order-laptop ds-col-order-desktop`"
    :style="{
      '--order-mobile': orderMobileWithFallback,
      '--order-laptop': orderLaptopWithFallback,
      '--order-desktop': orderDesktopWithFallback,
    }"
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@import '../../assets/scss/shared/ds.variables.module';
@import '../../assets/scss/shared/mixins';

@include mobile() {
  .ds-col-order-mobile {
    order: var(--order-mobile);
  }
}

@include laptop() {
  .ds-col-order-laptop {
    order: var(--order-laptop);
  }
}

@include desktop() {
  .ds-col-order-desktop {
    order: var(--order-desktop);
  }
}
</style>
